import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../lib/redux/hook'
import { LayoutComponent } from '../../ui/layout'
import { ButtonComponent } from '../../ui/molecules/button'
import { ErrorPopup } from '../../ui/organisms/errorPopup'
import { Pagination } from '../../ui/organisms/pagination'
import { MenuItems } from '../../ui/organisms/sidebar/dto'
import { SuccessPopup } from '../../ui/organisms/successPopup'
import { setCreateUserRequestName, setCreateUserRequestSurname, setCreateUserRequestEmail, setOpenNewUserModal, setCreateUserStatus, setDeleteUserStatus, setEditUserStatus, setUserFilterPage, findAllUser } from './slice'
import { OperatorIcon } from '../../ui/icons/operatorIcon'
import { NewUserModal } from './newUserModal'
import { UserList } from './list'
import { BillowButton } from '../../ui/molecules/billowButton'
import { PlusIcon } from '../../ui/icons/plusIcon'

export default function User() {

    const dispatch = useAppDispatch()
    const userState = useAppSelector(state => state.user)
 
    useEffect(() => {
        dispatch(findAllUser({ ...userState.userFilters, page: userState.userFilters.page }))
    }, [userState.userFilters.page])

    return (
        <LayoutComponent
            breadcrumbItems={['Utenti']}
            headingLabel={"Utenti"}
            headingButtons={[
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: 16 }}>
                    <BillowButton
                    icon={<PlusIcon size={'20'} color={'white'}/>}
                        label={"Crea utente"}
                        onClick={() => {
                            dispatch(setCreateUserRequestName(""))
                            dispatch(setCreateUserRequestSurname(""))
                            dispatch(setCreateUserRequestEmail(""))
                            dispatch(setOpenNewUserModal(true))
                        }}
                        variant={"solid"}
                        iconPosition="off"
                    />
                </div>
            ]}
            menuItem={MenuItems.USERS}
            breadcrumbIcon={<OperatorIcon color={'#6237FB'} size={"20"} />}
        >
            <ErrorPopup
                active={userState.createUserStatus === 'failed'}
                close={() => dispatch(setCreateUserStatus('idle'))}
                message="Si è verificato un errore durante la creazione dell'utente"
            />
            <SuccessPopup
                active={userState.createUserStatus === 'successfully'}
                close={() => dispatch(setCreateUserStatus('idle'))}
                message="Utente aggiunto con successo!"
            />
            <ErrorPopup
                active={userState.deleteUserStatus === 'failed'}
                close={() => dispatch(setDeleteUserStatus('idle'))}
                message="Si è verificato un errore durante l'eliminazione dell'utente"
            />
            <SuccessPopup
                active={userState.deleteUserStatus === 'successfully'}
                close={() => dispatch(setDeleteUserStatus('idle'))}
                message="Utente eliminato"
            />
            <ErrorPopup
                active={userState.editUserStatus === 'failed'}
                close={() => dispatch(setEditUserStatus('idle'))}
                message="Si è verificato un errore durante la modifica dell'utente"
            />
            <SuccessPopup
                active={userState.editUserStatus === 'successfully'}
                close={() => dispatch(setEditUserStatus('idle'))}
                message="Utente modificato"
            />
            <UserList />
            {
                userState.findAllUserResponse &&
                userState.findAllUserResponse?.users.length > 0 &&
                <div className="flex bg-white drop-shadow-sm items-center justify-center p-2">
                    <Pagination
                        pages={userState.findAllUserResponse?.totalPage || 1}
                        currentPage={userState.userFilters.page}
                        setPage={(page) => dispatch(setUserFilterPage(page))}
                    />
                </div>
            }
            <NewUserModal />
        </LayoutComponent>
    )
}
